import type { ModuleConfig } from '@berky/module-contract'

export interface NavigationCategory {
  id: string
  title: string
  description: string
  markerText: string
  colorHex: string
  sortOrder: number
  isActive: boolean
}

export interface ModuleNavigationAssignment {
  categoryId: string
  sortOrder: number
}

export interface ModuleNavigationSetting {
  moduleId: string
  categories: ModuleNavigationAssignment[]
  isVisible: boolean
}

export interface FavoritesResponse {
  moduleIds: string[]
}

export interface NavigationGroup {
  category: NavigationCategory
  modules: ModuleConfig[]
}

export const DEFAULT_NAVIGATION_CATEGORIES: NavigationCategory[] = [
  {
    id: 'hauptprozess',
    title: 'Hauptprozess',
    description: 'Die zentralen Anwendungen für Ihre täglichen Prozesse.',
    markerText: '01',
    colorHex: '#102757',
    sortOrder: 0,
    isActive: true,
  },
  {
    id: 'vertrieb',
    title: 'Vertrieb',
    description: 'Kunden, Leistungen und vertriebliche Abläufe im Blick.',
    markerText: '02',
    colorHex: '#087FA5',
    sortOrder: 1,
    isActive: true,
  },
  {
    id: 'technik',
    title: 'Technik',
    description: 'Technologische Werkzeuge für intelligente Lösungen.',
    markerText: '03',
    colorHex: '#1E8449',
    sortOrder: 2,
    isActive: true,
  },
  {
    id: 'produktion',
    title: 'Produktion',
    description: 'Anwendungen für Fertigung, Maschinen und Betrieb.',
    markerText: '04',
    colorHex: '#4D545A',
    sortOrder: 3,
    isActive: true,
  },
  {
    id: 'kundendienst',
    title: 'Kundendienst',
    description: 'Kundenbetreuung, Service und Lösungen im direkten Kontakt.',
    markerText: '05',
    colorHex: '#7C3AED',
    sortOrder: 4,
    isActive: true,
  },
  {
    id: 'verwaltung',
    title: 'Verwaltung',
    description: 'Organisation und Standards für nachhaltigen Erfolg.',
    markerText: '06',
    colorHex: '#F7A600',
    sortOrder: 5,
    isActive: true,
  },
]

const DEFAULT_CATEGORIES: Partial<Record<string, string[]>> = {
  beispiel: ['technik'],
  'ki-badges': ['verwaltung'],
  liquiditaet: ['verwaltung'],
  'maehboot-versenken': ['produktion'],
  meilensteine: ['hauptprozess'],
  'service-hub': ['vertrieb'],
  'reisekosten-belege': ['vertrieb', 'kundendienst'],
}

/**
 * Startzustand bis die Plattform-API geantwortet hat. Bekannte Module erhalten
 * die vereinbarte Einordnung; neue Module bleiben bewusst unveröffentlicht.
 */
export function defaultNavigationSettings(
  modules: ModuleConfig[],
): ModuleNavigationSetting[] {
  return modules.map((module) => ({
    moduleId: module.id,
    categories: (DEFAULT_CATEGORIES[module.id] ?? []).map((categoryId) => ({
      categoryId,
      sortOrder: module.order,
    })),
    isVisible: module.id in DEFAULT_CATEGORIES,
  }))
}

export function findCategoryAssignment(
  setting: ModuleNavigationSetting | undefined,
  categoryId: string,
): ModuleNavigationAssignment | undefined {
  return setting?.categories.find((assignment) => assignment.categoryId === categoryId)
}
